module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (12).e44ff85d.jpg";